<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs2></v-flex>
      <v-flex xs8>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="step > 1"
              >Option</v-stepper-step
            >
            <v-divider />
            <v-stepper-step step="2" :complete="step > 2"
              >Renewal</v-stepper-step
            >
            <v-divider />
            <v-stepper-step step="3" :complete="step > 3">Days</v-stepper-step>
            <v-divider />
            <v-stepper-step step="4">Quantity</v-stepper-step>
          </v-stepper-header>
          <connection-manager
            ref="connectionManager"
            v-model="connecting"
          ></connection-manager>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-select
                v-model="optionId"
                :items="options"
                hide-details
                class="mb-1"
                item-text="name"
                item-value="id"
                label="Select a subscription option"
                placeholder="Subscription option"
              >
              </v-select>
              <v-slide-y-transition>
                <v-card flat tile v-if="option">
                  <v-list
                    :style="
                      'max-height: ' + $vuetify.breakpoint.height * 0.3 + 'px;'
                    "
                    class="scroll-y"
                  >
                    <template v-for="(optionItem, index) in option.items">
                      <v-list-tile
                        @click="selectedOptionItem = optionItem"
                        :key="index"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            optionItem.name
                          }}</v-list-tile-title>
                          <v-list-tile-sub-title
                            >{{ $app.formatMoney(optionItem.price) }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider
                        v-if="index < option.items.length"
                        :key="option.items.length + index"
                      ></v-divider>
                    </template>
                  </v-list>
                  <v-chip class="mt-3" label outline color="info" small>
                    <v-icon left>info</v-icon>
                    Select {{ option.name }} to subscribe to from the above list
                  </v-chip>
                </v-card>
              </v-slide-y-transition>
              <v-card>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat @click.native="onClose(false)" color="red"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="primary"
                    v-if="selectedOptionItem"
                    @click.native="step = 2"
                  >
                    Subscribe for {{ selectedOptionItem.name }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-slide-y-transition>
                <v-card v-if="weekdays.length && step === 2">
                  <v-card-text>
                    <div>
                      <v-radio-group v-model="renewal" :mandatory="false">
                        <v-radio
                          label="Renew every month"
                          color="orange"
                          :disabled="connecting"
                          value="renew_every_month"
                        ></v-radio>
                        <v-radio
                          label="One time"
                          color="orange"
                          :disabled="connecting"
                          value="one_time_subscription"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn flat @click.native="step = 1">
                      <v-icon left>arrow_back</v-icon>
                      Back
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="onClose(false)" color="red"
                      >Cancel</v-btn
                    >
                    <v-btn color="primary" @click.native="step = 3">
                      Continue
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-slide-y-transition>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-slide-y-transition>
                <v-card>
                  <v-card-text
                    v-if="
                      weekdays.length &&
                        step === 3 &&
                        renewal === 'renew_every_month'
                    "
                  >
                    <v-list
                      dense
                      :style="
                        'max-height: ' +
                          $vuetify.breakpoint.height * 0.45 +
                          'px;'
                      "
                      class="scroll-y"
                    >
                      <v-list-tile v-for="item in weekdays" :key="item.id">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-checkbox v-model="item.selected"></v-checkbox>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                    <v-chip
                      class="mt-3 caption"
                      label
                      outline
                      color="info"
                      small
                    >
                      <v-icon left>info</v-icon>
                      Select on which days we should deliver your subscription
                      from the above list
                    </v-chip>
                  </v-card-text>
                  <v-card-text v-else>
                    <v-text-field
                      v-model="terminationDate"
                      required
                      :disabled="connecting"
                      hide-details
                      @click="showSelectTerminationDateDialog = true"
                      label="Select date for this subscription"
                      placeholder="Date for this subscription"
                    >
                    </v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn flat @click.native="step = 2">
                      <v-icon left>arrow_back</v-icon>
                      Back
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      flat
                      v-if="selectedOptionItem"
                      @click="step = 2"
                    >
                      <v-icon left>check_circle</v-icon>
                      {{ selectedOptionItem.name }} @
                      {{ $app.formatMoney(selectedOptionItem.price) }}
                    </v-btn>
                    <v-btn flat @click.native="onClose(false)" color="red"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="primary"
                      :disabled="selectedWeekdays <= 0 && !terminationDate"
                      @click.native="step = 4"
                    >
                      Continue
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-slide-y-transition>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-card flat tile>
                <v-layout row wrap align-center justify-center>
                  <v-flex xs12>
                    <!--<p class="caption accent text&#45;&#45;white px-5" v-if="showSubscriptionPeriodGuide">-->
                    <!--{{renewEveryMonthHint}}-->
                    <!--</p>-->
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="quantity"
                      required
                      mask="###"
                      label="Enter quantity"
                      :disabled="connecting"
                      :hide-details="renewEveryMonth"
                      placeholder="Quantity to be delivered"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-if="!renewEveryMonth"
                      v-model="terminationDate"
                      :required="!renewEveryMonth"
                      :disabled="connecting"
                      hide-details
                      @click="showSelectTerminationDateDialog = true"
                      label="Select date for this subscription"
                      placeholder="Date for this subscription"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-dialog
                  v-model="showSelectTerminationDateDialog"
                  max-width="290px"
                  lazy
                >
                  <v-card tile flat>
                    <v-date-picker
                      v-model="terminationDate"
                      :allowed-dates="allowedDates"
                    ></v-date-picker>
                  </v-card>
                </v-dialog>

                <v-list
                  dense
                  :style="
                    'max-height: ' + $vuetify.breakpoint.height * 0.3 + 'px;'
                  "
                  class="scroll-y"
                  v-show="renewEveryMonth"
                >
                  <v-list-tile
                    v-for="item in weekdays"
                    :key="item.id"
                    v-if="item.selected"
                  >
                    <v-list-tile-content>
                      <v-list-tile-sub-title>
                        {{
                          item.days +
                            ' ' +
                            item.name +
                            '' +
                            (item.days > 1 ? 's' : '')
                        }}
                        <b>
                          {{
                            renewEveryMonth
                              ? ' this month '
                              : ' between now and ' + terminationDate
                          }}
                        </b>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

                <v-slide-y-transition>
                  <div v-if="terminationDate || renewEveryMonth">
                    <v-btn color="primary" small flat outline>
                      Total Item Cost :
                      <b> {{ $app.formatMoney(costs.item) }}</b>
                    </v-btn>
                    <v-btn color="primary" small flat outline>
                      Total Delivery Cost :
                      <b> {{ $app.formatMoney(costs.delivery) }}</b>
                    </v-btn>
                    <v-chip
                      v-if="renewEveryMonth"
                      class="mt-3 caption"
                      label
                      outline
                      color="info"
                      small
                    >
                      <v-icon v-show="renewEveryMonth" left>info</v-icon>
                      {{ costsDescription }}
                    </v-chip>
                  </div>
                </v-slide-y-transition>

                <v-card-actions>
                  <v-btn flat @click.native="step = 3">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    flat
                    v-if="selectedOptionItem"
                    @click="step = 1"
                  >
                    <v-icon left>check_circle</v-icon>
                    {{ selectedOptionItem.name }} @
                    {{ $app.formatMoney(selectedOptionItem.price) }}
                  </v-btn>
                  <v-btn flat @click.native="onClose(false)" color="red"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="primary"
                    :disabled="
                      !quantity ||
                        connecting ||
                        (!terminationDate && !renewEveryMonth)
                    "
                    @click.native="submit"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
      <v-flex xs2></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ConnectionManager from './ConnectionManager'
import moment from 'moment'
import EventBus from '../event-bus'

export default {
  name: 'AddSubscription',
  components: { ConnectionManager },
  props: {
    show: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      showSubscriptionPeriodGuide: false,
      connecting: false,
      showSelectTerminationDateDialog: false,
      step: 1,
      options: [],
      option: null,
      optionId: null,
      selectedOptionItem: null,
      weekdays: [],
      quantity: null,
      terminationDate: null,
      renewEveryMonth: true,
      oneTimeSubscription: false,
      daysToDeliver: 0,
      renewal: 'renew_every_month',
      allowedTimes: {
        hours: function(value) {
          return value >= moment().hour()
        },
        minutes: function(value) {
          return value % 15 === 0
        },
        dates: function(date) {
          if (moment().hour() >= 16) {
            return moment(moment(date)).isAfter(moment())
          } else {
            return moment(moment(date)).isAfter(moment())
          }
          // YYYY/MM/DD
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      }
    }
  },
  watch: {
    optionId(val) {
      if (val) {
        this.option = this.options.find(function(element) {
          return element.id === val
        })
        this.selectedOptionItem = null
      }
    },
    renewal(val) {
      if (val === 'renew_every_month') {
        this.renewEveryMonth = true
        this.showSubscriptionPeriodGuide = true
        this.showSubscriptionPeriodGuide = false
        this.updateDays()
      } else {
        this.renewEveryMonth = false
        this.showSubscriptionPeriodGuide = false
        this.showSubscriptionPeriodGuide = false
        this.updateDays()
      }
    },
    showSubscriptionPeriodGuide(val) {
      if (val) {
        let that = this
        setTimeout(function() {
          that.showSubscriptionPeriodGuide = false
        }, 5000)
      }
    },
    step(val) {
      if (val === 4) {
        this.updateDays()
        this.showSubscriptionPeriodGuide = true
      }
      if (val === 3) {
      }
    },
    renewEveryMonth(val) {
      this.showSubscriptionPeriodGuide = true
      this.updateDays()
    },
    terminationDate(val) {
      if (val) {
        this.showSelectTerminationDateDialog = false
        this.renewEveryMonth = false
        this.showSubscriptionPeriodGuide = true
        this.updateDays()
      }
    }
  },
  computed: {
    renewEveryMonthHint() {
      return this.renewEveryMonth
        ? 'Un check "Renew every month" to specify a date to terminate this subscription'
        : 'Check "Renew every month" to renew this subscription every month'
    },
    allowedSubscriptionDates() {
      return {
        dates: function(date) {
          // YYYY/MM/DD
          return moment(moment(date)).isAfter(moment())
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      }
    },
    costsDescription() {
      return (
        'Above are costs ' +
        (this.renewEveryMonth
          ? ' for this month'
          : ' between now and ' + this.terminationDate) +
        ' (' +
        this.daysToDeliver +
        ' days)'
      )
    },
    selectedWeekdays() {
      let selected = 0
      for (let schedule of this.weekdays) {
        if (schedule.selected) {
          selected++
        }
      }
      return selected
    },
    costs() {
      if (this.step === 4) {
        this.daysToDeliver = 0

        for (let weekday of this.weekdays) {
          if (weekday.selected) {
            this.daysToDeliver += weekday.days
          }
        }
        this.$app.log(this.daysToDeliver)
        if (this.renewEveryMonth) {
          return {
            item:
              this.selectedOptionItem.price *
              this.quantity *
              this.daysToDeliver,
            // delivery: this.option.deliveryCost * this.quantity * this.daysToDeliver
            delivery: this.option.deliveryCost * 0
          }
        } else {
          return {
            item: this.selectedOptionItem.price * this.quantity,
            // delivery: this.option.deliveryCost * this.quantity * this.daysToDeliver
            delivery: this.option.deliveryCost * 0
          }
        }
      } else {
        return {
          item: 0,
          delivery: 0
        }
      }
    }
  },
  methods: {
    onClose(val) {
      this.step = 1
      this.optionId = null
      this.option = null
      this.selectedOptionItem = null
      this.terminationDate = null
      this.renewEveryMonth = true
      this.quantity = null
      this.options = []
      for (let i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].selected = false
      }
      this.$emit('onClose', val)
    },
    allowedDates(date) {
      if (moment().hour() >= 16) {
        return moment(moment(date)).isAfter(moment().add(1, 'days'))
      } else {
        return moment(moment(date)).isAfter(moment())
      }
    },
    resetDays() {
      // Initialize days of weekdays in the subscribed period
      for (let i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].days = 0
      }
    },

    updateDays() {
      this.resetDays()

      if (this.renewEveryMonth) {
        // Date today
        let currentDayOfThisMonth = moment(this.systemVariables.date).date()
        this.$app.log('currentDayOfThisMonth = ' + currentDayOfThisMonth)

        // Date of the last day of this month
        let lastDayOfThisMonth = moment(this.systemVariables.date)
          .endOf('month')
          .date()
        this.$app.log('lastDayOfThisMonth = ' + lastDayOfThisMonth)

        // Add one to #currentDayOfThisMonth so as not to include today
        for (let i = currentDayOfThisMonth + 1; i <= lastDayOfThisMonth; i++) {
          // Weekday number of the date
          let weekdayNumber = moment()
            .date(i)
            .weekday()
          // Updates number of days of the weekday number in the current month
          this.updateWeekdayDays(weekdayNumber)
        }
      } else if (this.terminationDate) {
        // Calculate days to deliver until the termination date

        let terminationDayOfYear = moment(this.terminationDate).dayOfYear()
        // Weekday number of the day of year
        let weekdayNumber = moment()
          .dayOfYear(terminationDayOfYear)
          .weekday()
        // select the weekday and set the days count to one
        for (let i = 0; i < this.weekdays.length; i++) {
          let weekday = this.weekdays[i]
          if (weekday.number === weekdayNumber) {
            this.weekdays[i].selected = true
            this.weekdays[i].days = 1
            break
          }
        }

        // Add one to #currentDayOfYear so as not to include today
        // for (let i = (currentDayOfYear + 1); i <= terminationDayOfYear; i++) {
        // Weekday number of the day of year
        // let weekdayNumber = moment().dayOfYear(i).weekday()
        // Updates number of days of the weekday number in the current month
        // this.updateWeekdayDays(weekdayNumber)
        // }
      }
    },

    updateWeekdayDays(weekdayNumber) {
      // Check if weekday number is selected, if selected update days of that weekday in the subscription period
      for (let i = 0; i < this.weekdays.length; i++) {
        let weekday = this.weekdays[i]
        if (weekday.number === weekdayNumber && weekday.selected) {
          this.weekdays[i].days++
          break
        }
      }
    },
    submit() {
      let selectedWeekdayNumbers = []
      for (let weekday of this.weekdays) {
        if (weekday.selected) {
          selectedWeekdayNumbers.push(weekday.number)
        }
      }
      let subscription = {
        renewEveryMonth: this.renewEveryMonth,
        terminationDate: this.terminationDate,
        weekdays: selectedWeekdayNumbers.join('#'),
        quantity: this.quantity,
        deliveryCost: this.costs.delivery,
        itemCost: this.costs.item,
        optionItemId: this.selectedOptionItem.id,
        optionId: this.optionId
      }
      let that = this

      this.$refs.connectionManager.post(
        'subscriptions',
        {
          onSuccess(response) {
            const filter = 'pendingApproval'
            that.$router.push({ name: 'subscriptions', params: { filter } })
            EventBus.$emit(that.$actions.addedSubscription)
            that.onClose(true)
          }
        },
        subscription
      )
    },
    loadSubscriptionOptions() {
      let that = this
      this.$refs.connectionManager.get(
        'subscriptionOptions',
        {
          onSuccess(response) {
            that.options = []
            that.options = that.options.concat(response.data.data)
            that.systemVariables = response.data.systemVariables
            that.weekdays = []
            that.weekdays.push({ name: 'Monday', number: 1, days: 0 })
            that.weekdays.push({ name: 'Tuesday', number: 2, days: 0 })
            that.weekdays.push({ name: 'Wednesday', number: 3, days: 0 })
            that.weekdays.push({ name: 'Thursday', number: 4, days: 0 })
            that.weekdays.push({ name: 'Friday', number: 5, days: 0 })
            that.weekdays.push({ name: 'Saturday', number: 6, days: 0 })
            that.weekdays.push({ name: 'Sunday', number: 0, days: 0 })
          }
        },
        { withSystemVariables: true }
      )
    }
  },
  created() {
    if (this.options.length === 0) {
      let that = this
      setTimeout(function() {
        that.loadSubscriptionOptions()
      }, 300)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/AddSubscription.vue